export const FOOTER_LEGAL_DOCS = {
  legal: 'https://encargomio.com/documentos/ENCARGOMIO_TERMINOS_Y_CONDICIONES.pdf',
} as const;
